import { UpdatePackage } from "./UpdatePackage";
import { UpdatePackageAssociationEnum } from "./UpdatePackageAssociationEnum";

export class UpdatePackageAssociation extends UpdatePackage {
    public association: UpdatePackageAssociationEnum;

    public parse(obj: any) {
        super.parse(obj);
    }
}
